import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { PaymentV2Service, UtilService, VariablesService } from '../../shared/services';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-slabs-v2',
  templateUrl: './slabs-v2.component.html',
  styleUrls: ['./slabs-v2.component.scss']
})
export class SlabsV2Component implements OnInit {
  @Input() config;
  @Output() amountChange: EventEmitter<any> = new EventEmitter();

  amountForm: FormGroup
  amount:  FormControl
  defaultAmount;
  max_donation = 50000000;
  slab_amount = [101, 201, 501];
  value = 100;
  placeholder;
  touched;
  slabAmount_clicked;
  constructor(
    public paymentv2: PaymentV2Service,
    public vars: VariablesService,
    public util: UtilService
  ) { }

  ngOnInit() {
    this.amountForm = new FormGroup({
      amount: this.amount = new FormControl('', [
        Validators.required, Validators.pattern(/^[0-9]+$/), Validators.min(this.config?.contributeDetails.min_donation), Validators.max(this.max_donation)
      ]),
    });
    this.defaultAmount = Math.round(this.config?.lastOrder?.donated_amount_local * 1.2);
    this.patchForm();
    this.amountChange.emit(this.defaultAmount);
    this.amount.valueChanges.subscribe((res) => {
      this.defaultAmount = res; 
      this.amountChange.next(res || 0)
    });

  }

  addAmount(amount) {
    this.defaultAmount = this.defaultAmount + amount;
    document.getElementById('amount-animation').classList.add('animation-start')
    this.slabAmount_clicked = amount;
    setTimeout(() => {
      document.getElementById('amount-animation').classList.remove('animation-start')
    }, 1500);
    this.patchForm();
    this.amountChange.emit(this.defaultAmount);
  }

  patchForm() {
    this.amountForm.patchValue({
      'amount': this.defaultAmount
    });
  }

  focus() {
    this.touched = true;
    document.getElementById('amount-input').focus()
  }

  setAmount() {
    this.defaultAmount = this.amount.value;
  }

}
